import React from 'react';
import { Crown, RightTriangle } from 'sushiweb/Icons';

export const DelightFeatureTag = ({
  featureDetails = null,
  onClick = () => {},
}) => {
  return (
    <div className='mt10 mb10'>
      <div
        className='pointer'
        style={{
          backgroundColor: featureDetails.bg_color,
          border: `1px solid ${featureDetails.color}`,
          borderRadius: 6,
          padding: '0 1rem',
        }}
        onClick={onClick}
      >
        <Crown size={12} color={featureDetails.color} />
        <p
          className='iconMarginR iconMarginL small'
          style={{ color: featureDetails.color }}
        >
          {featureDetails.name}
        </p>
        <RightTriangle size={10} color={featureDetails.color} />
      </div>
    </div>
  );
};
